module.exports = __webpack_public_path__ + "img/snapchat.2943f0a9.svg";